export enum EPOIPerm {
    CHECKPOINTS_VIEW = 'pois_view',
    CHECKPOINTS_DELETE = 'pois_delete',
    CHECKPOINTS_EDIT = 'pois_edit'
}
